var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-full text-gray-900 bg-box-whitemode",attrs:{"id":"app"}},[_c('Layout',{staticClass:"safe-area-inset-bottom w-full h-full bg-white"},[_c('router-view',{key:_vm.viewKey,staticClass:"w-full h-full"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }